import { Action } from '@ngrx/store';
import * as InitialQuestionResultActions from '../actions/initialQuestion.action';

export type Actions = InitialQuestionResultActions.Actions;

export function InitialQuestionReducer(state: any[] = [],
    action: InitialQuestionResultActions.Actions) {
    switch (action.type) {
        case InitialQuestionResultActions.ADD_INITIALQUESTION_RESULT:
            return [...state, action.payload];

        // Add this case:
        case InitialQuestionResultActions.REMOVE_INITIALQUESTION_RESULT:
            return [...state].splice(action.payload, 1);
        default:
            return state;
    }
}

